import { TicketDetails } from "features/types";
import i18n from "plugins/localization";

export const barcodeHoursBefore = (
  barcodeMinutesBefore: TicketDetails["barcodeMinutesBefore"]
) => {
  const hours = Math.floor(barcodeMinutesBefore / 60);
  const minutes = barcodeMinutesBefore % 60;
  const hoursDisplay = `${i18n.t("common.hour", {
    count: hours,
  })}`;
  const minutesDisplay = `${i18n.t("common.minute", {
    count: minutes,
  })}`;
  if (hours > 0 && minutes > 0) {
    return `${hoursDisplay} ${minutesDisplay}`;
  } else if (hours > 0) {
    return hoursDisplay;
  } else if (minutes > 0) {
    return minutesDisplay;
  }
};
